var map = {
	"./bg-image.png": "49c5",
	"./home/celeris-logo.svg": "ba85",
	"./home/clp.png": "91c0",
	"./home/line.png": "0f38",
	"./home/whitelabelpayments-logo.svg": "7dc7",
	"./home/wlp.png": "c16c",
	"./logo-bg.png": "7fe7",
	"./logo.png": "cf05",
	"./logo.svg": "9b19"
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = "1771";